module.exports = __webpack_public_path__ + "static/media/logo.f1cf1272.svg";